import axios from "axios";
var Filter = require('bad-words'),
    filter = new Filter();
export default {
  antIsClean: function (text){
    if (text !== filter.clean(text)){
      return false;
    };
    
    for(let x = 0; x<(text.length-1); x++){
    
      if(x<=(text.length-3)){
        console.log('3' , text.slice(x,x+3))
          if(text.slice(x,x+3) !== filter.clean(text.slice(x,x+3))){
            return false;
           }
           if(x<=(text.length-4)){
            console.log('4' , text.slice(x,x+4))
              if(text.slice(x,x+4) !== filter.clean(text.slice(x,x+4))){
                return false;        
           }
                if(x<=(text.length-5)){
            // console.log('5' , text.slice(x,x+5))
                  if(text.slice(x,x+5) !== filter.clean(text.slice(x,x+5))){
                  return false;
            }
            if(x<=(text.length-6)){
              // console.log('5' , text.slice(x,x+5))
                    if(text.slice(x,x+6) !== filter.clean(text.slice(x,x+6))){
                    return false;
              }
             }
           }
        }
      }
      
    
      
    
    
  }
  return true;
  },
  profileRequest: function(requestObj, cb){
    console.log('HERE!!!');  
    console.log('IN ProfileRequestAPI', requestObj);
    axios.post("../profile/request", requestObj).then(function (response) {      
          if(!response.data){ }else{
            console.log('AXIOS RESPONSE', response);
          if(!response.data.username){
            console.log('bad');
            return cb(response.data);
           
          }else{
            response.data.newuser = requestObj;
            console.log('good');
            return cb(response.data);
          };  
          
          
        }}).catch(function (error) {
          
          return cb(error);}
        );
 
  //   console.log(requestObj);
  //   return cb('Success');},
  
  },
  resetPassword: function(resetObj, cb){
    console.log('IN RESET');
    axios.post("/password/reset", resetObj)
    .then(function (response) {      
          console.log('Success?',response.data);
          return cb(response.data);
        })
    .catch(function (error) {
          console.log('RESET ERROR');
          return cb(error);
        });
 
    console.log(resetObj);
    return cb('Success');
},
  requestreset: function(email, cb){
    //cb EXPECTS cb('Email Sent'), cb('No Email')
    //return cb('No Email');
    
    if(!email){
      return cb('No In Email');
    }
    if(!email.email){
      return cb('No In Email');
    }
    
    console.log('API IN', '../password/request/' + email.email);
    axios.get('../password/request/' + email.email)
    .then(function(data){
      return cb(data);
    }).catch(function (error) {

      return cb(error);
    });
    
  }, 
  autolog: function(onboardid, email,cb){
    console.log('IN API');
    //confirm/autologin/17973/napolitano.anthony73@gmail.com
    axios.get('../autologin/' + onboardid +'/' + email).then(
    ).then(function(data){
      return cb(data);
    }
      
      
    
    )
    .catch(function (error) {

      return cb({err:error});
    });
  },
  getUser: function(cb){

    axios.get('./api/getUser').then(
    ).then(function (response) {
      
      return cb(response.data);
    })
    .catch(function (error) {
    console.log(error);
      return cb({usr:false});
    });
   
  },
  login: function(username,password,cb){
    console.log('IN LOGIN')
      let newLogin = {
          email: username,
          password: password
        }
        axios.post('./api/login', newLogin)
        .then(function (response) {
      
          return cb(response.data);
        })
        .catch(function (error) {
          console.log('USER NOT FOUND');
          return cb({usr:false});
        });
 
  },
  logout: function(cb){
    axios.get('./api/logout')
    .then(function (response) {
    
      return cb();
    })
    .catch(function (error) {
    
      return cb();
    });
    return cb();
  },
  sendUserInvite: function(Reg, cb){
    
    axios.post('./api/register', Reg)
    .then(function (response) {  
 
      return cb(response.data);
    })
    .catch(function (error) {
      console.log('Error?', error)
            return cb(error);
      // console.log('USER NOT FOUND');
      // return cb({usr:false});
    });

    
    return cb();
  //   axios.get('./api/logout')
  //   .then(function (response) {
    
  //     return cb();
  //   })
  //   .catch(function (error) {
    
  //     return cb();
  //   });
  //   return cb();
  }}
 



// WEBPACK FOOTER //
// ./src/utilities/API.js